
import { Component, HostListener, OnInit, ViewEncapsulation, OnDestroy, Input } from '@angular/core';
import { NgClass, NgFor, NgStyle } from '@angular/common';
import { ProductsService } from '@shared/services/products.service';
import { SharedService } from '@core/services/shared.service';
import { environment } from 'src/environments/environment';
import { loadCachedScript } from 'src/app/utils/load-script';
import { customEcommerce } from 'src/assets/custom-ecommerce/custom';
import { KeycloakService } from 'keycloak-angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AppService } from '@core/services/app.service';
import { Subscription } from 'rxjs';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import {FormsModule} from '@angular/forms';
import { SearchBarComponent } from './widgets/search-bar/search-bar.component';
import { CartSummaryComponent } from './widgets/cart-summary/cart-summary.component';
import { MenuComponent } from './widgets/menu/menu.component';

@Component({
    selector: 'app-main-header',
    templateUrl: './main-header.component.html',
    styleUrls: ['./main-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
  imports: [
    NgClass,
    RouterLink,
    NgStyle,
    SearchBarComponent,
    CartSummaryComponent,
    MenuComponent,
    FormsModule,
    TranslateModule
  ]
})
export class MainHeaderComponent implements OnInit, OnDestroy {

  @Input('forceSolidBgColor') set in(value: boolean) {
    this._forceSolidBgColor = value;
    this.setBackground();
  };
  iFrameDetection: boolean;
  areaImage: any = null;
  customHeader : any
  isCustom : boolean = false;
  isUserPR : boolean = false;
  bearerUser: string = '';
  isLoggedin : boolean = false;
  activeMenuIndex = 0;
  isDropDownClosed : boolean = true;
  isHeaderBreakpoint: boolean = false;
  isSmallScreen: boolean = false;
  readonly maxWidthBreakpoint: number = 820;
  _forceSolidBgColor: boolean = false;
  defaultBgColor: string;

  displayDate: boolean = true;
  intervalId: any;
  areInPrRoutes: boolean
  hideSearchBar: boolean
  subscription : Subscription

  languages = [
    { code: 'it', name: 'Italiano' },
    { code: 'en', name: 'English' },
    { code: 'de', name: 'Deutsch' },
    { code: 'es', name: 'Español' },
    { code: 'fr', name: 'Français' },
    { code: 'pt', name: 'Português' },
    { code: 'el', name: 'Ελληνικά' },
    { code: 'ru', name: 'Русский' },
    { code: 'ro', name: 'Română' },
    { code: 'sq', name: 'Shqiptare' },
  ];

    languageSelected : string;
  languageNameSelected : string;


  displayLanguages = [];

  constructor(
    private productService: ProductsService,
    public sharedService: SharedService,
    private keycloakAngular: KeycloakService,
    private appService: AppService,
    private router: Router,
    private translate: TranslateService,
  )  {
     this.languageSelected = localStorage.getItem('language') || this.getDeviceLanguage();
      this.translate.setDefaultLang(this.languageSelected);
      this.translate.use(this.languageSelected);
      this.languageNameSelected = this.languageSelected ? this.languages.find(l => l.code === this.languageSelected).code : "it";

    this.isHeaderBreakpoint = window.innerWidth <= this.maxWidthBreakpoint;
    this.isSmallScreen = window.innerWidth <= 576;
    this.iFrameDetection = this.sharedService.isIframeDetection();
    this.customHeader = customEcommerce[this.sharedService.getCustomDomain()];
  }

  ngOnInit() {
     this.displayLanguages = this.languages;
    this.hideSearchBar = this.checkHideSearchBar(this.router.url);
    this.subscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
       this.areInPrRoutes = this.sharedService.checkCurrentRoute(event.url);
       this.hideSearchBar = this.checkHideSearchBar(event.url);
      }
    });
    this.startInterval()
    this.isCustom = this.sharedService.checkRoute();
    this.keycloakAngular.isLoggedIn().then(logined => {
      this.isLoggedin = logined;
      this.isUserPR = this.sharedService.isUserPr;
      if (this.isLoggedin) {
        this.keycloakAngular.loadUserProfile().then(profile => {
          this.sharedService.bearerUser$.next(profile);
          this.bearerUser = profile.firstName + ' ' + profile.lastName;
        })
      }
    })
    
    loadCachedScript(`assets/js/menu.js?cb=${environment.cb}`);
    this.productService.areaImage.subscribe(
      (image) => {
        this.areaImage = image;
      }
    )
    this.setBackground();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    clearInterval(this.intervalId);
  }
 getDeviceLanguage(): string {
    const language = navigator.language.split('-')[0];
  
    return this.sharedService.languages.includes(language) ? language : 'en';
  }



 changeLanguage(language) {
    this.translate.use(language.code);
    this.languageSelected = language.code;
    this.languageNameSelected = language.code;
    this.appService.setDefaultLanguage(language.code)
    this.isDropDownClosed = true
  }

  toggleDropdown(){
   this.isDropDownClosed = !this.isDropDownClosed;
   const selectedIndex = this.languages.findIndex(lang => lang.code === this.languageSelected);
   if (selectedIndex > -1) {
     const selectedLanguage = this.languages[selectedIndex];
     this.displayLanguages = [
       selectedLanguage,
       ...this.languages.filter((_, index) => index !== selectedIndex)
     ];
   }
   
  }


  
  startInterval() {
    this.intervalId = setInterval(() => {
        this.displayDate = !this.displayDate; 
    }, 4000);    
  }

  @HostListener('window:resize')
  onResize() {
    this.isHeaderBreakpoint = window.innerWidth <= this.maxWidthBreakpoint;
    this.isSmallScreen = window.innerWidth <= 576;
    this.setBackground();
  }

  setBackground() {
    if (this.isHeaderBreakpoint) {
      this.defaultBgColor = "#F1F3F7";
    } else {
      this.defaultBgColor = this._forceSolidBgColor === true ? "#fff" : "linear-gradient(180deg, #FFFFFF 50%, rgba(255, 255, 255, 0) 100%)";
    }
  }

  checkHideSearchBar(url: string): boolean {
    return url.split('?')[0].split('#')[0].replace(/\/$/, '') === '/gestisci';
  }

  onLogoClick(navigate: boolean) {
    if(this.areInPrRoutes) return;
    if (navigate) {
      window.open('https://www.ciaotickets.com/', '_self');
    }
  }

  onLoginClick() {
    this.sharedService.onLoginParentShare();
    this.keycloakAngular.login({ prompt: 'login', locale: this.translate.currentLang || this.languageSelected || 'it' });

  }

  navigateToPr() {
    this.router.navigate(['/promoter/dashboard']);
  }

  navigateToUserDashboard() {
    // this.router.navigate(['/user/dashboard']);
  }
}
